
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestearpluglawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestearpluglawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestearpluglawyers/privacy-policy"])
      });
    }
  